const validate = {
  rules: {
    nome: {
      required: true,
    },
    telefone: {
      required: true,
    },
    whatsapp: {
      required: false,
    },
    endereco: {
      required: false,
    },
    email: {
      required: false,
    },
    nome_in: {
        required: false
    },
    nome_es: {
        required: false
    }
  },
  messages: {
    nome: "O nome é obrigatório.",
    telefone: "O telefone é obrigatório.",
  },
};

export default validate;
